export const GRAPH_TYPES = {
  CANDLESTICK: 'candlestick',
  AREA: 'area',
};

